/**
 * Error Handler Utility
 * Formats API errors for user-friendly display
 */

export const formatError = (error) => {
  if (error.response) {
    const status = error.response.status
    const data = error.response.data

    if (data.error) {
      return data.error
    }

    switch (status) {
      case 400:
        return 'Invalid request. Please check your input.'
      case 401:
        return 'Authentication required. Please log in.'
      case 403:
        return 'You do not have permission to perform this action.'
      case 404:
        return 'Resource not found.'
      case 409:
        return 'Conflict: The resource was modified by another user. Please refresh and try again.'
      case 413:
        return 'File is too large. Maximum size is 5 MB.'
      case 500:
        return 'Server error. Please try again later.'
      default:
        return `Error ${status}: An error occurred`
    }
  }

  if (error.request) {
    return 'Network error. Please check your connection and try again.'
  }

  return error.message || 'An unexpected error occurred'
}




